import watchGetGlossaryRequested from './getGlossarySaga';

export default [
  watchGetGlossaryRequested(),
];
